"use strict";

(function () {
    EWS.DashboardItemTypesManager.add("Report", {
        showEditButton: true,
        // enableFilters: true,
        itemFields: ["ReportID", "Options"],
        addItem(createNewItemCallback) {
            EWS.SavedReport.Select((control, report, title) => {
                const OptionsData = CheckOptions(control, title);
                if (!OptionsData.status) {
                    return;
                }
                const optionsJson = OptionsData.optionsJson || {};
                const saveObject = {};
                saveObject.ReportID = report;
                if (Object.keys(optionsJson).length > 0) {
                    saveObject.Options = JSON.stringify(optionsJson);
                }
                createNewItemCallback(title, saveObject);
            }, null, "", "", "", "", true, "", "", "", "", CreateOptionsHtml());
        },
        editItem(title, itemFields, dashboardItem, editItemCallback) {
            const Options = JSON.parse(itemFields.Options || "{}");
            const myGetReportOwnerByReportIDRequest = new ECP.EC_Request("DashboardWidget_GetReportOwnerByReportID");

            myGetReportOwnerByReportIDRequest.AddRequestVariable("ReportID", itemFields.ReportID);

            myGetReportOwnerByReportIDRequest.Submit().then((result) => {
                const owner = result.Owner;
                const authenticationID = result.AuthenticationID;
                EWS.SavedReport.Select((control, report, _title) => {
                    const OptionsData = CheckOptions(control, _title);
                    if (!OptionsData.status) {
                        return;
                    }
                    const optionsJson = OptionsData.optionsJson || {};
                    const saveObject = {};
                    saveObject.ReportID = report;
                    if (Object.keys(optionsJson).length > 0) {
                        saveObject.Options = JSON.stringify(optionsJson);
                    }
                    editItemCallback(_title, saveObject);
                }, null, title, itemFields.ReportID, owner, "", true, authenticationID, "", "", "", CreateOptionsHtml(Options));
            });
        },
        createViewButtons(dashboardItem) {
            const reportActionArr = dashboardItem.querySelectorAll(".edit-control .report-action");

            for (let i = 0; i < reportActionArr.length; i++) {
                const reportAction = reportActionArr[i];
                reportAction.parentElement.removeChild(reportAction);
            }

            const newActionArr = Array.from(dashboardItem.querySelectorAll(".widget-action"));
            const ecpMenu = newActionArr[0]?.querySelector("ecp-menu ecp-list");

            if (ecpMenu) {
                AddReportExportMenuItems(dashboardItem, ecpMenu);
            }

            return newActionArr;
        },
        onLoaded(dashboardItem) {
            // Task 628177: No 'Loading' message is shown when refreshing a report on a dashboard
            // EC-3416: Dashboard Items: Add min-height and max-height options
            if (!dashboardItem.style.height && !dashboardItem.style.minHeight) {
                dashboardItem.style.minHeight = "50px";
            }

            const LoadReportHtml = async () => {
                const html = await DashboardWidget_GetReportHtml(dashboardItem);

                dashboardItem.querySelector(".content").innerHTML = html;
                dashboardItem.removeAttribute("data-widget-mincachetime");

                const fluxViewContainer = dashboardItem.querySelector(".FluxViewContainer");
                if (fluxViewContainer) {
                    EC_Fmt.LoadScript("includes/Styles/FusionReport.css");
                    EC_Fmt.LoadScript("Reporting_ECP/FluxView.js", () => {
                        const ReportID = EC_Fmt.Null2ZeroInt(fluxViewContainer.getAttribute("ReportID"));
                        const ReportUrl = fluxViewContainer.getAttribute("src");
                        FillFusionReportInDashboard(fluxViewContainer, ReportID, ReportUrl);
                    });
                }
                // Task 673644:
                const reportViewContainer = dashboardItem.querySelector(".ReportViewContainer");
                if (reportViewContainer) {
                    EC_Fmt.LoadScript("Reporting_ECP/ReportView.js");
                    EC_Fmt.LoadScript("includes/Styles/Workbook.css");
                    EC_Fmt.LoadScript("includes/Workbook_INC.js", () => {
                        const ReportID = EC_Fmt.Null2ZeroInt(reportViewContainer.getAttribute("ReportID"));
                        const ReportUrl = reportViewContainer.getAttribute("src");
                        FillComparisonReportInDashboard(reportViewContainer, ReportID, ReportUrl);
                    });
                }
            };
            if (EC_Fmt.GetPageParameter("DashboardEdit")?.toLowerCase() === "true") {
                LoadReportHtml();
            }
            return LoadReportHtml;
        }
    });

    const ReportGraphType = {
        showEditButton: true,
        itemFields: ["ReportID", "Display", "Source", "ChartParameters", "Options"],
        async addItem(createNewItemCallback) {
            await Open_ReportGraph_Dialog((report, graph, title, source, chartParameters, options) => {
                createNewItemCallback(title, {
                    ReportID: report,
                    Display: graph,
                    Source: source,
                    ChartParameters: chartParameters,
                    Options: options
                });
            });
        },
        editItem(title, itemFields, dashboardItem, editItemCallback) {
            const myGetReportOwnerByReportIDRequest = new ECP.EC_Request("DashboardWidget_GetReportOwnerByReportID");

            myGetReportOwnerByReportIDRequest.AddRequestVariable("ReportID", itemFields.ReportID);

            myGetReportOwnerByReportIDRequest.Submit().then(async (result) => {
                const owner = result.Owner;
                const authenticationID = result.AuthenticationID;

                await Open_ReportGraph_Dialog((report, graph, _title, source, chartParameters, options) => {
                    editItemCallback(_title, {
                        ReportID: report,
                        Display: graph,
                        Source: source,
                        ChartParameters: chartParameters,
                        Options: options
                    });
                }, title, itemFields, owner, authenticationID);
            });
        },
        createViewButtons(dashboardItem, itemFields) {
            const reportActionArr = dashboardItem.querySelectorAll(".edit-control .report-action");

            for (let i = 0; i < reportActionArr.length; i++) {
                const reportAction = reportActionArr[i];
                reportAction.parentElement.removeChild(reportAction);
            }

            const newActionArr = Array.from(dashboardItem.querySelectorAll(".widget-action"));
            const ecpMenu = newActionArr[0].querySelector("ecp-menu ecp-list");

            const graphIcon = EC_Fmt.HtmlStrToElement(`<ecp-list-item title="Switch Graph"><span class="ews-icon-graph"></span><ecp-list-item-title>Switch Graph</ecp-list-item-title></ecp-list-item>`);
            let menuName = "SwitchGraphMenu";
            if (itemFields.Source === "fusion") {
                menuName = "FusionSwitchGraphMenu";
            }

            const handleGraphIconClick = function () {
                EWS.Command.ShowMenu(menuName, this, {
                    switchGraph(graph) {
                        dashboardItem.setAttribute("data-itemfield-display", graph);
                        dashboardItem.querySelector(".content").innerHTML = "";

                        LoadDashboardItem(dashboardItem);
                    }
                });
            };

            graphIcon.addEventListener("click", handleGraphIconClick);

            if (ecpMenu) {
                ecpMenu.appendChild(graphIcon);
            }

            const reportDataIcon = EC_Fmt.HtmlStrToElement(`<ecp-list-item title="Report Data"><span class=ews-icon-tablegrid></span><ecp-list-item-title>Report Data</ecp-list-item-title></ecp-list-item>`);

            const handleReportDataClick = function () {
                const FluxViewContainer = dashboardItem.querySelector(".report-action.ews-icon-break-out");
                let StrParameters = "";
                if (FluxViewContainer) {
                    const dashboardFusionArr = EC_Fmt.GetURLParameters(EC_Fmt.Null2EmptyStr(FluxViewContainer.closest("a").getAttribute("href")));
                    if (dashboardFusionArr && EC_Fmt.Null2ZeroInt(dashboardFusionArr.ReportID) > 0) {
                        itemFields.ReportID = EC_Fmt.Null2ZeroInt(dashboardFusionArr.ReportID);
                    }
                    if (!EC_Fmt.isNull(dashboardFusionArr.Parameters)) {
                        StrParameters = EC_Fmt.Null2EmptyStr(dashboardFusionArr.Parameters);
                    }
                }
                const FusionRequest = new ECP.EC_Request("FusionView");
                FusionRequest.SetReturnType(ECP.EC_ReturnType.Text);
                FusionRequest.AddRequestVariable("ReportID", itemFields.ReportID);
                FusionRequest.AddRequestVariable("Format", "HTML");
                FusionRequest.AddRequestVariable("EmbededDialog", "True");
                FusionRequest.AddRequestVariable("LoadData", "True");
                FusionRequest.AddRequestVariable("Display", "0");
                if (!EC_Fmt.isNull(StrParameters)) {
                    if (StrParameters.length > 4000) {
                        FusionRequest.AddRequestVariable("Parameters", StrParameters, ECP.EC_Verb.Post);
                    } else {
                        FusionRequest.AddRequestVariable("Parameters", StrParameters, ECP.EC_Verb.Get);
                    }
                }
                FusionRequest.Submit().then((reportHtml) => {
                    const Dialog = ECP.Dialog.ShowDialog("Report Data", reportHtml, {
                        width: 825,
                        height: 396,
                        cancelButtonTitle: "Close"
                    });
                    const confirmBtn = Dialog.querySelector(".ecp-dialog-confirm-button");
                    if (confirmBtn) {
                        confirmBtn.remove();
                    }
                });
            };

            reportDataIcon.addEventListener("click", handleReportDataClick);

            if (ecpMenu) {
                ecpMenu.appendChild(reportDataIcon);
            }

            AddReportExportMenuItems(dashboardItem, ecpMenu);

            return newActionArr;
        },
        onLoaded(dashboardItem, itemFields) {
            const LoadReportHtml = async () => {
                const html = await DashboardWidget_GetReportHtml(dashboardItem, dashboardItem.getAttribute("data-itemfield-display"), dashboardItem.getAttribute("data-itemfield-chartparameters"));

                dashboardItem.querySelector(".content").innerHTML = html;
                dashboardItem.removeAttribute("data-widget-mincachetime");
                if (itemFields.Source === undefined) {
                    // Needed to handle old dashboard items that don't have Source set
                    const breakOut = dashboardItem.querySelector("a .ews-icon-break-out");

                    if (breakOut) {
                        const viewURL = breakOut.getAttribute("href");

                        if (viewURL?.includes(`DashboardID=${ECP.CommonDashboards.FusionView}`)) {
                            itemFields.Source = "fusion";
                        } else {
                            itemFields.Source = "report";
                        }
                    }
                }

                const fluxViewContainer = dashboardItem.querySelector(".FluxViewContainer");
                if (fluxViewContainer) {
                    EC_Fmt.LoadScript("includes/Styles/FusionReport.css");
                    EC_Fmt.LoadScript("Reporting_ECP/FluxView.js", () => {
                        const ReportID = EC_Fmt.Null2ZeroInt(fluxViewContainer.getAttribute("ReportID"));
                        const ReportUrl = fluxViewContainer.getAttribute("src");
                        FillFusionReportInDashboard(fluxViewContainer, ReportID, ReportUrl);
                    });
                } else {
                    // Task 688118: Comparison Report Graph is not showing on Dashboard
                    const reportViewContainer = dashboardItem.querySelector(".ReportViewContainer");
                    if (reportViewContainer) {
                        const ReportID = EC_Fmt.Null2ZeroInt(reportViewContainer.getAttribute("ReportID"));
                        const ReportUrl = reportViewContainer.getAttribute("src");
                        FillComparisonReportInDashboard(reportViewContainer, ReportID, ReportUrl);
                    }
                }
            };
            if (EC_Fmt.GetPageParameter("DashboardEdit")?.toLowerCase() === "true") {
                LoadReportHtml();
            }
            return LoadReportHtml;
        }
    };

    EWS.DashboardItemTypesManager.add("ReportGraph", ReportGraphType);

    // Dashboard Widget
    EWS.DashboardItemTypesManager.add("Report Graph", ReportGraphType);

    async function Open_ReportGraph_Dialog(callback, title, itemFields, owner, userID) {
        let ReportID = "";
        let Display = "";
        let ChartParameters = "";
        let Options = "";
        if (itemFields) {
            Display = itemFields.Display;
            ChartParameters = itemFields.ChartParameters;
            ReportID = itemFields.ReportID;
            Options = JSON.parse(itemFields.Options || "{}");
        }
        const optionsHtml = CreateOptionsHtml(Options);
        EWS.SavedReport.Select((control, report, _title, source) => {
            EWS.VerifySession(async () => {
                const OptionsData = CheckOptions(control, _title);
                if (!OptionsData.status) {
                    return;
                }
                const optionsJson = OptionsData.optionsJson || {};
                const selectArgs = {
                    callback(_control, graph, chartParameters) {
                        if (!EC_Fmt.isNull(callback)) {
                            callback(report, graph, _title, source, chartParameters, Object.keys(optionsJson).length > 0 ? JSON.stringify(optionsJson) : null);
                        }
                    },
                    Source: source
                };
                if (selectArgs.Source === "fusion") {
                    const graphHtmlDiv = document.createElement("div");
                    graphHtmlDiv.id = "GraphHtml";
                    const Dialog = ECP.Dialog.ShowDialog("Select Graph Type", graphHtmlDiv, {
                        width: window.innerWidth * 0.6,
                        height: window.innerHeight * 0.7,
                        cancelButtonTitle: "Cancel",
                        confirmButtonAction() {
                            if (selectArgs.callback && selectArgs.callback !== undefined) {
                                // Task 1021160: When adding a Report Graph to a dashboard, display a dialog for the Chart Settings
                                const container = Dialog.querySelector("#GraphHtml");
                                let newChartTypeId = 0;
                                if (!EC_Fmt.isNull(container.querySelector(".graphOptionContainer.currentGraphOption"))) {
                                    newChartTypeId = EC_Fmt.Null2ZeroInt(container.querySelector(".graphOptionContainer.currentGraphOption").getAttribute("charttypeid"));
                                }
                                if (newChartTypeId === 0) {
                                    ECP.Dialog.HideLoading();
                                    ECP.Dialog.Alert("Please select chart.");
                                    return;
                                }
                                const parameters = {};
                                const selectInputArr = container.querySelectorAll("div.parameter-field select");
                                for (let i = 0; i < selectInputArr.length; i++) {
                                    parameters[selectInputArr[i].getAttribute("parameterKey")] = selectInputArr[i].options[selectInputArr[i].selectedIndex].value;
                                }
                                const textInputArr = container.querySelectorAll("div.parameter-field input, div.parameter-field ecp-input, div.parameter-field ecp-auto-complete");
                                for (let i = 0; i < textInputArr.length; i++) {
                                    parameters[textInputArr[i].getAttribute("parameterKey")] = textInputArr[i].value;
                                }
                                const keyValueColors = JSON.parse(document.querySelector("#graphRender svg.ews-chart").getAttribute("data")).parameters.keyValueColors;
                                parameters.keyValueColors = Object.entries(keyValueColors || {}).map(item => item.join(":")).join(",");

                                ECP.Dialog.CloseDialog(Dialog);
                                selectArgs.callback(control, newChartTypeId, JSON.stringify(parameters));
                            }
                        }

                    });
                    const jsPromises = [
                        EC_Fmt.LoadScript("Reporting_ECP/FluxGraph.js"),
                        EC_Fmt.LoadScript("includes/d3_INC.js"),
                        EC_Fmt.LoadScript("includes/Styles/FluxGraph.css")
                    ];
                    if (jsPromises) {
                        await Promise.all(jsPromises);
                    }
                    DashboardItemCreateGraph(null, report, Display, ChartParameters);
                    const ActionButtonSaveGraph = Dialog.querySelector("#ActionButtonSaveGraph");
                    if (ActionButtonSaveGraph) {
                        ActionButtonSaveGraph.remove();
                    }
                } else {
                    const myReportGraphDialogContentRequest = new ECP.EC_Request("DashboardWidget_ReportGraphDialogContent");
                    myReportGraphDialogContentRequest.AddRequestVariable("Source", selectArgs.Source);
                    myReportGraphDialogContentRequest.Submit().then((result) => {
                        const Dialog = ECP.Dialog.ShowDialog(result.title, result.html, {
                            width: 825,
                            height: 396,
                            cancelButtonTitle: result.cancel
                        });

                        Dialog.querySelector(".ecp-dialog-confirm-button").style.display = "none";
                        const graphContainer = Dialog.querySelector("#ews-dashboard-graphs");
                        graphContainer.addEventListener("click", (e) => {
                            const target = e.target.closest(".ews-dashboard-graph-icon");
                            if (target) {
                                const graph = target.getAttribute("graph");
                                if (selectArgs.callback && selectArgs.callback !== undefined) {
                                    ECP.Dialog.CloseDialog(Dialog);
                                    selectArgs.callback(control, graph);
                                }
                            }
                        });
                    });
                }
            });
        }, null, title, ReportID, owner, "", true, userID, "", "", [ECP.CommonDashboards.FusionView, ECP.CommonDashboards.ReportView], optionsHtml);
    }

    EWS.Ready(() => {
        EWS.Command.AddMenu("SwitchGraphMenu", (control, name, menu, callback) => {
            let menuHtml = "";

            menuHtml += `<div class=ews-menu-item command="Area Graph">`
                + `<div class="ews-menu-icon ews-icon-areagraph"></div>`
                + `<div class=ews-menu-label>`
                + ` Area Graph`
                + `</div>`
                + `</div>`

                + `<div class=ews-menu-item command="Bar Graph">`
                + `<div class="ews-menu-icon ews-icon-bargraph"></div>`
                + `<div class=ews-menu-label>`
                + ` Bar Graph`
                + `</div>`
                + `</div>`

                + `<div class="ews-menu-item" command="Column Graph">`
                + `<div class="ews-menu-icon ews-icon-columngraph"></div>`
                + `<div class="ews-menu-label">`
                + ` Column Graph`
                + `</div>`
                + `</div>`

                + `<div class=ews-menu-item command="Line Graph">`
                + `  <div class="ews-menu-icon ews-icon-report"></div>`
                + `  <div class=ews-menu-label>`
                + `       Line Graph`
                + `  </div>`
                + `</div>`

                + `<div class=ews-menu-item command="Pie Chart">`
                + `<div class="ews-menu-icon ews-icon-graph"></div>`
                + `<div class=ews-menu-label>`
                + ` Pie Chart`
                + `</div>`
                + `</div>`

                + `<div class=ews-menu-item command="Doughnut Chart">`
                + `<div class="ews-menu-icon ews-icon-doughnut"></div>`
                + `<div class=ews-menu-label>`
                + ` Doughnut Chart`
                + `</div>`
                + `</div>`;

            menu.innerHTML = menuHtml;
            callback(control, menu);
        }, (control, name, menu, arg) => {
            menu = EC_Fmt.RemoveAllEventListeners(menu);

            menu.addEventListener("click", (event) => {
                const target = event.target.closest(".ews-menu-item");

                if (target) {
                    EWS.Command.HideAllMenus();
                    arg.switchGraph(target.getAttribute("command"));
                }
            });
        });

        EWS.Command.AddMenu("FusionSwitchGraphMenu", async (control, name, menu, callback) => {
            const myRequest = new ECP.EC_Request("GetChartTypes");
            const result = await myRequest.Submit();
            let menuHtml = "";

            for (let i = 0; i < result.chartTypes.length; i++) {
                menuHtml += `<div class=ews-menu-item command="${result.chartTypes[i].chartTypeId}">`
                    + `<div class="ews-menu-icon ${result.chartTypes[i].iconClass}"></div>`
                    + `<div class=ews-menu-label>`
                    + ` ${result.chartTypes[i].name}`
                    + `</div>`
                    + `</div>`;
            }

            menu.innerHTML = menuHtml;
            callback(control, menu);
        }, (control, name, menu, arg) => {
            menu = EC_Fmt.RemoveAllEventListeners(menu);

            menu.addEventListener("click", (event) => {
                const target = event.target.closest(".ews-menu-item");

                if (target) {
                    EWS.Command.HideAllMenus();
                    arg.switchGraph(target.getAttribute("command"));
                }
            });
        });
    });
}());

async function FillFusionReportInDashboard(el, ReportID, ReportUrl) {
    el.innerHTML = "";
    el.style.minHeight = "300px";
    const dashboardItem = el.closest("[class*=dashboard-item]");
    const LoadingItem = ECP.Dialog.ShowLoading(null, dashboardItem);
    let myFluxDisplay = new FluxDisplay({ el, ReportID });
    await myFluxDisplay.InitPinnedFilter();
    const FusionFilters = el.querySelector(".FiltersContent");
    if (FusionFilters && !EC_Fmt.isNull(FusionFilters.innerHTML)) {
        FusionFilters.setAttribute("hidden", "");
        FusionFilters.remove();
        if (!dashboardItem.querySelector(".edit-control ecp-menu [name=filter]")) {
            const overflowBtn = dashboardItem.querySelector(".edit-control ecp-menu ecp-list");
            const FilterBtn = EC_Fmt.HtmlStrToElement(`<ecp-list-item name=filter title="Filter"><span class="ews-icon-filter"></span><ecp-list-item-title>Filter</ecp-list-item-title></ecp-list-item>`);
            if (overflowBtn) {
                overflowBtn.appendChild(FilterBtn);
            }
            FilterBtn.addEventListener("click", async () => {
                let Dialog = document.querySelector(`#Item_Filters_${dashboardItem.id}`);
                if (!Dialog) {
                    Dialog = ECP.Dialog.ShowDialog("Filters", "<div name=currentFilter></div>", {
                        confirmButtonAction: () => {
                            const btn = Dialog.querySelector(".ecp-fusion-pinned-override-submit input");
                            if (btn) {
                                EC_Fmt.TriggerEvent(btn, "click");
                            }
                        }
                    });
                    const currentFilter = Dialog.querySelector("div[name=currentFilter]");
                    currentFilter.setAttribute("src", el.getAttribute("src"));
                    const myFluxDisplayFilter = new FluxDisplay({ el: currentFilter, ReportID });
                    await myFluxDisplayFilter.InitPinnedFilter((data) => {
                        const expandBtn = dashboardItem.querySelector(".edit-control .ews-icon-break-out").closest("a");
                        expandBtn.href = `Home?${EC_Fmt.GetURL_QueryString(expandBtn.href, "Parameters;ReportID", "")}&ReportID=${data.ReportID}${EC_Fmt.isNull(data.Parameters) ? "" : `&Parameters=${data.Parameters}`}`;
                        const FluxViewContainer = dashboardItem.querySelector(".FluxViewContainer");
                        if (FluxViewContainer && data.Parameters !== null) {
                            const URL = `api?${EC_Fmt.GetURL_QueryString(FluxViewContainer.getAttribute("src"), "Parameters;ReportID", "")}&ReportID=${data.ReportID}${EC_Fmt.isNull(data.Parameters) ? "" : `&Parameters=${data.Parameters}`}`;
                            FluxViewContainer.setAttribute("src", URL);
                        }
                        let format = "Dashboard";
                        let display = "";
                        if (dashboardItem.getAttribute("item-type") === "ReportGraph" || dashboardItem.getAttribute("item-type") === "Report Graph") {
                            format = "Graph";
                            display = dashboardItem.getAttribute("data-itemfield-display");
                        }
                        FillFusionReportInDashboard(el, data.ReportID, `api?APICommand=FusionView&ReportID=${data.ReportID}&Format=${format}&Display=${display}&EmbededDialog=True&LoadData=True${EC_Fmt.isNull(data.Parameters) ? "" : `&Parameters=${data.Parameters}`}&${EC_Fmt.GetURL_QueryString(FluxViewContainer.getAttribute("src"), "", "OrderBy;Expand")}`);
                        return false;
                    });
                    Dialog.querySelector(".ecp-fv_flex").remove();
                    Dialog.querySelector(".ecp-fusion-pinned-override-filters").style = "";
                    Dialog.id = `Item_Filters_${dashboardItem.id}`;
                } else {
                    Dialog.style.display = "";
                }
            });
        }
    }

    const ReportFilters = el.querySelector("#FiltersrequiredShow");
    if (ReportFilters && EC_Fmt.isNull(ReportFilters.innerHTML)) {
        const reportType = el.getAttribute("reporttype");
        let topRecordCount = el.getAttribute("toprecordcount");
        let IsDataLoadMoreButton = false;
        let IsPivotReport = false;
        if (reportType && topRecordCount) {
            IsPivotReport = reportType === "Piovt";
            topRecordCount = EC_Fmt.CDec(topRecordCount);
            const DefaultLoadedRows = IsPivotReport ? 50 : 200;
            if (topRecordCount === 0 || (topRecordCount > DefaultLoadedRows)) {
                ReportUrl += `&TopRecordCount=${DefaultLoadedRows}`;
                el.setAttribute("CurTopRecordCount", DefaultLoadedRows);
                IsDataLoadMoreButton = true;
            }
        }

        const InitReportDataLoadMore = async (NewReportUrl, IsLoadAll) => {
            IsDataLoadMoreButton = false;
            if (IsLoadAll) {
                NewReportUrl = `api?${EC_Fmt.GetURL_QueryString(NewReportUrl, "TopRecordCount")}`;
                el.removeAttribute("CurTopRecordCount");
            } else {
                let DefaultLoadedRows = EC_Fmt.CDec(el.getAttribute("CurTopRecordCount"));
                const newtoprecordcount = EC_Fmt.CDec(el.getAttribute("toprecordcount"));
                const TypeIsPivotReport = el.getAttribute("reporttype") === "Piovt";
                if (TypeIsPivotReport) {
                    DefaultLoadedRows += 50;
                } else {
                    DefaultLoadedRows += 500;
                }
                if (newtoprecordcount === 0 || (newtoprecordcount > DefaultLoadedRows)) {
                    ReportUrl += `&TopRecordCount=${DefaultLoadedRows}`;
                    el.setAttribute("CurTopRecordCount", DefaultLoadedRows);
                    IsDataLoadMoreButton = true;
                } else {
                    NewReportUrl = `api?${EC_Fmt.GetURL_QueryString(NewReportUrl, "TopRecordCount")}`;
                    el.removeAttribute("CurTopRecordCount");
                }
                NewReportUrl = `api?${EC_Fmt.GetURL_QueryString(NewReportUrl, "TopRecordCount")}TopRecordCount=${DefaultLoadedRows}`;
            }
            LoadReportHtml(NewReportUrl);
        };
        const LoadReportHtml = async (NewReportUrl) => {
            const LoadingHTMLItem = ECP.Dialog.ShowLoading(null, dashboardItem);
            const ReportGraph = el.closest("[item-type='Report Graph']");
            const response = await fetch(`api?${EC_Fmt.GetURL_QueryString(NewReportUrl, "LoadFusionFields")}&LoadFusionFields=true`, { credentials: "same-origin" });
            let reportHtml = await response.text();
            if (IsDataLoadMoreButton) {
                const ReportDataLoadMore = `<div class=bottomLoadMore style="padding:0 0 20px 32px"><ecp-btn class=ReportDataLoadMore>Load ${IsPivotReport ? 50 : 500} more</ecp-btn><ecp-btn class=ReportDataLoadAll style="padding-left: 60px;">Load All Rows</ecp-btn></div>`;
                reportHtml += ReportDataLoadMore;
            }
            const reportHtmlDom = document.createElement("div");
            reportHtmlDom.classList.add("reporthtml");
            reportHtmlDom.style.padding = "10px 0";
            reportHtmlDom.innerHTML = reportHtml;

            if (IsDataLoadMoreButton) {
                const Parent = reportHtmlDom.querySelectorAll("tr[rowtype=Parent]").length;
                const LoadedRows = Parent > 0 ? Parent : reportHtmlDom.querySelectorAll("tr[rowtype=Detail]").length;
                const DefaultLoadedRows = EC_Fmt.CDec(el.getAttribute("CurTopRecordCount")) || 0;
                if (DefaultLoadedRows !== LoadedRows) {
                    IsDataLoadMoreButton = false;
                    reportHtmlDom.querySelector(".bottomLoadMore").remove();
                }
            }

            if (IsDataLoadMoreButton) {
                reportHtmlDom.querySelector(".ReportDataLoadMore").addEventListener("click", async () => { InitReportDataLoadMore(NewReportUrl); });
                reportHtmlDom.querySelector(".ReportDataLoadAll").addEventListener("click", async () => { InitReportDataLoadMore(NewReportUrl, true); });
            }

            if (el.querySelector(".reporthtml")) {
                el.querySelector(".reporthtml").remove();
            }

            el.appendChild(reportHtmlDom);
            const chart = el.querySelector("svg.ews-chart");
            if (chart) {
                EC_Fmt.LoadScript("includes/Styles/FluxGraph.css");
                EC_Fmt.LoadScript("Reporting_ECP/FluxGraph.js").then(async () => {
                    EC_Fmt.LoadScript("includes/d3_INC.js").then(async () => {
                        await EC_FluxGraph.initChart(chart);
                        ECP.Dialog.HideLoading(LoadingHTMLItem);
                    });
                });
            } else if (ReportGraph) {
                el.appendChild(EC_Fmt.HtmlStrToElement(`<ecp-empty illustration=empty><ecp-empty-title>No Results</ecp-empty-title></ecp-empty>`));
            }
            el.style.minHeight = "";

            const options = dashboardItem.getAttribute("data-itemfield-options");
            let OptionsStr = {};
            if (!EC_Fmt.isNull(options)) {
                try {
                    OptionsStr = JSON.parse(options);
                } catch (e) {
                    OptionsStr = {};
                }
            }
            const content = dashboardItem.querySelector(".header");
            let ItemTitle = content.innerHTML;
            const includeGroupBy = ItemTitle.includes("{{Group By}}") && OptionsStr.EnableGroupBy;
            const includeComparison = ItemTitle.includes("{{Comparison Option}}") && OptionsStr.EnableComparisonOption;

            if ((includeGroupBy || includeComparison) && !dashboardItem.querySelector(".ItemHeader")) {
                content.style.display = "none";
                if (includeGroupBy) {
                    const groupByList = dashboardItem.querySelector("[name=GroupByList]");
                    const groupByCurentValue = groupByList.value.split("^")[0];
                    const groupByInput = `<ecp-auto-complete class=GroupByAutoInput name="GroupByParent_${dashboardItem.id}" isSearch="false" limitToRefList="true" valuesArr="${groupByList.value}" value="${groupByCurentValue}"></ecp-auto-complete>`;
                    ItemTitle = ItemTitle.replace("{{Group By}}", groupByInput);
                }
                if (includeComparison) {
                    const comparisonList = dashboardItem.querySelector("[name=ComparisonList]");
                    const comparisonCurentValue = comparisonList.value.split("^");
                    let comparisonInput = "";
                    if (comparisonCurentValue.length > 0) {
                        const columnValue = comparisonList.getAttribute("columnValue");
                        comparisonInput = `<ecp-auto-complete class=ComparisonAutoInput name="ComparisonOption_${dashboardItem.id}" isSearch="false" limitToRefList="true" valuesArr="${comparisonList.value}" value="${columnValue}"></ecp-auto-complete>`;
                    }
                    ItemTitle = ItemTitle.replace("{{Comparison Option}}", comparisonInput);
                }
                const reportTitleDom = `<div class=ItemHeader><span class=reportTitle>${ItemTitle}</span> </div>`;
                content.insertAdjacentHTML("beforebegin", reportTitleDom);
            }

            if (includeGroupBy || includeComparison) {
                const GroupByAutoInput = dashboardItem.querySelector(".GroupByAutoInput");
                if (GroupByAutoInput) {
                    GroupByAutoInput.removeEventListener("change", GroupByAutoInput._changeHandler);
                    GroupByAutoInput._changeHandler = async (e) => {
                        LoadReportHtml(`api?${EC_Fmt.GetURL_QueryString(NewReportUrl, "GroupBy_Parent")}&GroupBy_Parent=${e.target.value}`);
                    };
                    GroupByAutoInput.addEventListener("change", GroupByAutoInput._changeHandler);
                }

                const ComparisonAutoInput = dashboardItem.querySelector(".ComparisonAutoInput");
                if (ComparisonAutoInput) {
                    ComparisonAutoInput.removeEventListener("change", ComparisonAutoInput._changeHandler);
                    ComparisonAutoInput._changeHandler = async (e) => {
                        LoadReportHtml(`api?${EC_Fmt.GetURL_QueryString(NewReportUrl, "Column_Option;Comparison_Option")}&Comparison_Option=${e.target.value}`);
                    };
                    ComparisonAutoInput.addEventListener("change", ComparisonAutoInput._changeHandler);
                }
            }

            const cover = ECP.Dialog.ShowLoading(null, el.closest("[class*=dashboard-item]"));

            myFluxDisplay = new FluxDisplay({ el, ReportID });
            const match = (`${ReportUrl}&`).match(/Parameters=.*?(?=&)/i);
            if (match?.length > 0) {
                myFluxDisplay.ParametersStr = match[0].replace(/Parameters=/i, "");
            }

            myFluxDisplay.InitOrder((data) => {
                const _cover = ECP.Dialog.ShowLoading(null, el.closest(".dashboard-item"));
                const Order = data && !EC_Fmt.isNull(data.OrderBy) ? `&OrderBy=${data.OrderBy}` : "";
                const expandBtn = el.closest("[class*=dashboard-item]").querySelector(".edit-control .ews-icon-break-out").closest("a");
                el.setAttribute("src", `${EC_Fmt.GetURL_QueryString(el.getAttribute("src"), "ReportID;OrderBy", "")}&ReportID=${data.ReportID}${Order}`);
                expandBtn.href = `Home?${EC_Fmt.GetURL_QueryString(expandBtn.href, "ReportID;OrderBy", "")}&ReportID=${data.ReportID}${Order}`;
                FillFusionReportInDashboard(el, data.ReportID, `api?APICommand=FusionView&ReportID=${data.ReportID}&Format=Dashboard&EmbededDialog=True&LoadData=True&${EC_Fmt.GetURL_QueryString(expandBtn.href, "", "Parameters")}${Order}`).then(() => {
                    ECP.Dialog.HideLoading(_cover);
                });
                return false;
            });

            if (!ReportGraph) {
                myFluxDisplay.InitCollapsing("", EC_Fmt.GetURLParameters(ReportUrl).Expand);
            }

            myFluxDisplay.FixHeader();
            myFluxDisplay.InitDrillDown();
            myFluxDisplay.InitPostToDashboard();
            myFluxDisplay.LoadCommentHtml(false);
            ECP.Dialog.HideLoading(cover);
            if (!chart) {
                ECP.Dialog.HideLoading(LoadingHTMLItem);
            }
        };
        await LoadReportHtml(ReportUrl);
    }
    ECP.Dialog.HideLoading(LoadingItem);
}

function FillComparisonReportInDashboard(el, ReportID, ReportUrl) {
    return new Promise((resolve) => {
        const cover = ECP.Dialog.ShowLoading(null, el.closest(".dashboard-item"));
        const OldReportURL = EC_Fmt.GetURLParameters(ReportUrl);
        if (EC_Fmt.isNull(OldReportURL.BaseQuery)) {
            OldReportURL.BaseQuery = "";
        }
        ReportUrl = `api?APICommand=${OldReportURL.APICommand}&Format=${OldReportURL.Format}&ReportID=${ReportID}&MinCacheTime=${OldReportURL.MinCacheTime}&Action=${OldReportURL.Action}&BaseQuery=${OldReportURL.BaseQuery}&Parameters=${encodeURIComponent(OldReportURL.Parameters)}`;
        fetch(ReportUrl, {
            credentials: "same-origin"
        }).then(resp => resp.text()).then((reportHtml) => {
            el.innerHTML = reportHtml;
            const chart = el.querySelector("svg.ews-chart");
            if (chart) {
                EC_Fmt.LoadScript("includes/Styles/FluxGraph.css");
                EC_Fmt.LoadScript("Reporting_ECP/FluxGraph.js").then(() => {
                    EC_Fmt.LoadScript("includes/d3_INC.js").then(() => {
                        EC_FluxGraph.initChart(chart);
                    });
                });
            }
            ECP.Dialog.HideLoading(cover);
            resolve();
        }).catch((err) => {
            throw err;
        });
    });
}

function DashboardWidget_GetReportHtml(dashboardItem, graph, chartparameters) {
    const DashboardWidget = dashboardItem.getAttribute("item-type");
    const ReportID = EC_Fmt.Null2ZeroInt(dashboardItem.getAttribute("data-itemfield-reportid"));

    const myRequest = new ECP.EC_Request("Reporting_DashboardWidget_GetReportHtml");

    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
    myRequest.AddRequestVariable("ReportID", ReportID);
    myRequest.AddRequestVariable("DashboardWidget", DashboardWidget);
    myRequest.AddRequestVariable("dashboardItemID", dashboardItem.id);

    const filter = dashboardItem.getAttribute("data-widget-filter");
    if (!EC_Fmt.isNull(filter)) {
        myRequest.AddRequestVariable("Parameters", decodeURIComponent(filter.split("Parameters=")[1]));
    }

    if (!EC_Fmt.isNull(graph)) {
        myRequest.AddRequestVariable("Display", graph);
    }

    if (!EC_Fmt.isNull(chartparameters)) {
        myRequest.AddRequestVariable("ChartParameters", chartparameters);
    }

    const cacheTime = dashboardItem.getAttribute("data-widget-mincachetime");
    if (!EC_Fmt.isNull(cacheTime)) {
        myRequest.AddRequestVariable("MinCacheTime", decodeURIComponent(cacheTime));
    }

    return myRequest.Submit();
}

function AddReportExportMenuItems(dashboardItem, ecpMenu) {
    if (!ecpMenu) {
        return;
    }

    const existsCsv = ecpMenu.querySelector("ecp-list-item[name=export-csv]");
    if (!existsCsv) {
        const exportCsvIcon = EC_Fmt.HtmlStrToElement(`<ecp-list-item name=export-csv title="Export to CSV"><span class="ews-icon-text"></span><ecp-list-item-title>Export to CSV</ecp-list-item-title></ecp-list-item>`);
        exportCsvIcon.addEventListener("click", async () => {
            await DashboardReportExport(dashboardItem, "CSV");
        });
        ecpMenu.appendChild(exportCsvIcon);
    }

    const existsExcel = ecpMenu.querySelector("ecp-list-item[name=export-excel]");
    if (!existsExcel) {
        const exportExcelIcon = EC_Fmt.HtmlStrToElement(`<ecp-list-item name=export-excel title="Export to Excel"><span class="ews-icon-excel"></span><ecp-list-item-title>Export to Excel</ecp-list-item-title></ecp-list-item>`);
        exportExcelIcon.addEventListener("click", async () => {
            await DashboardReportExport(dashboardItem, "Excel");
        });
        ecpMenu.appendChild(exportExcelIcon);
    }
}

async function DashboardReportExport(dashboardItem, format) {
    const breakOut = dashboardItem.querySelector(".edit-control .ews-icon-break-out");
    const breakOutLink = breakOut ? breakOut.closest("a") : null;
    const reportContainer = dashboardItem.querySelector(".FluxViewContainer, .ReportViewContainer");

    if (!breakOutLink && !reportContainer) {
        return;
    }

    let exportSourceUrl = reportContainer ? reportContainer.getAttribute("src") : "";
    if (EC_Fmt.isNull(exportSourceUrl) && breakOutLink) {
        exportSourceUrl = breakOutLink.href;
    }

    try {
        const myRequest = new ECP.EC_Request("FileExport_ExportMenu");
        myRequest.AddRequestVariable("Url", exportSourceUrl, ECP.EC_Verb.Post);
        myRequest.AddRequestVariable("Formats", format);
        const result = await myRequest.Submit();

        const options = result && Array.isArray(result.options) ? result.options : [];
        let exportUrl = "";
        for (let i = 0; i < options.length; i++) {
            if (EC_Fmt.Null2EmptyStr(options[i].format).toLowerCase() === format.toLowerCase()) {
                exportUrl = options[i].url;
                break;
            }
        }

        if (!EC_Fmt.isNull(exportUrl)) {
            EC_Fmt.DownloadFileFromURL(exportUrl);
            return;
        }
    } catch (_err) {
        ECP.Dialog.Alert(EC_Fmt.Trn(`Download failed: ${_err.message || _err}`));
    }

    const fallbackUrl = `${EC_Fmt.GetURL_QueryString(exportSourceUrl, "Format;EmbededDialog", "")}&Format=${format}&_=${Date.now()}`;
    EC_Fmt.DownloadFileFromURL(fallbackUrl);
}

function DashboardRefreshReport(dashboardItem, cacheTime) {
    if (dashboardItem) {
        dashboardItem.setAttribute("data-widget-mincachetime", cacheTime);
        dashboardItem.querySelector(".content").innerHTML = "";
        const ReportID = dashboardItem.getAttribute("data-itemfield-reportid");
        const OrderMenuArr = document.querySelectorAll(`[id*=OrderMenu_${ReportID}]`);
        for (let i = 0; i < OrderMenuArr.length; i++) {
            OrderMenuArr[i].remove();
        }

        LoadDashboardItem(dashboardItem);
    }
}

function CreateOptionsHtml(Option) {
    const Options = Option || {};
    return `<div style=display:flex;flex-direction:column>
<div>
 <ecp-checkbox id=EnableGroupBy label="Enable Group By Toggle" ${Options.EnableGroupBy ? "checked" : ""}></ecp-checkbox>
 <i id=EnableGroupBytip class=ews-icon-info></i>
 <ecp-tooltip for=EnableGroupBytip placement=Right delayms=100 Tooltip>Allows users of the dashboard to switch the group by on the report.<br>This requires the report alias above to contain {{Group By}} in the text</ecp-tooltip>
</div>
<div style="padding-top:8px;">
 <ecp-checkbox id=EnableComparisonOption label="Enable Comparison Option Toggle" ${Options.EnableComparisonOption ? "checked" : ""}></ecp-checkbox>
 <i id=EnableComparisonOptiontip class="ews-icon-info"></i>
 <ecp-tooltip for=EnableComparisonOptiontip placement=Right delayms=100 Tooltip>Allows users of the dashboard to switch the group by on the report.<br>This requires the report alias above to contain {{Comparison Option}} in the text</ecp-tooltip>
</div>
</div>`;
}
function CheckOptions(control, _title) {
    const ReturnStatus = {};
    ReturnStatus.status = true;
    control.closeDialog = true;
    const EnableGroupBy = control.Dialog ? control.Dialog.querySelector("#EnableGroupBy") : null;
    const EnableComparisonOption = control.Dialog ? control.Dialog.querySelector("#EnableComparisonOption") : null;
    const optionsJson = {};
    if (EnableGroupBy) {
        optionsJson.EnableGroupBy = EnableGroupBy.checked;
    }
    if (EnableComparisonOption) {
        optionsJson.EnableComparisonOption = EnableComparisonOption.checked;
    }
    if (EnableGroupBy?.checked && !_title.includes("{{Group By}}")) {
        control.closeDialog = false;
        ECP.Dialog.Alert(`<span style=text-align:center>Cannot use the <b>Enable Group By Toggle</b> option unless the title contains "{{Group By}}".
<br><br>Please add the <b>{{Group By}}</b> text to the title where you want the toggle to be placed.
<br>{{Group By}} can only be present once in the title.</span>`);
        control.Dialog.querySelector("#ews-report-title").style.border = "2px solid red";
        ReturnStatus.status = false;
    }
    if (EnableComparisonOption?.checked && !_title.includes("{{Comparison Option}}")) {
        control.closeDialog = false;
        ECP.Dialog.Alert(`<span style=text-align:center>Cannot use the <b>Enable Comparison Option Toggle</b> option unless the title contains "{{Comparison Option}}".
<br><br>Please add the <b>{{Comparison Option}}</b> text to the title where you want the toggle to be placed.
<br>{{Comparison Option}} can only be present once in the title.</span>`);
        control.Dialog.querySelector("#ews-report-title").style.border = "2px solid red";
        ReturnStatus.status = false;
    }
    ReturnStatus.optionsJson = optionsJson;
    return ReturnStatus;
}
